import { FormEventHandler, MutableRefObject } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { BaseManuscriptSearchConditions, JudgmentDivision } from '../../../../api/model';
import MultiSelect from '../../../atoms/MultiSelect';
import SlideToggle from '../../../modules/SlideToggle';

interface Props {
  openSearchConditions: boolean;
  productionId: number;
  defaultConditions: BaseManuscriptSearchConditions;
  judgmentDivisions: JudgmentDivision[];
  conditionsRef: MutableRefObject<BaseManuscriptSearchConditions>;
  setConditionsAndSearch: (value: BaseManuscriptSearchConditions) => void;
}

function BaseManualSearch({
  openSearchConditions,
  productionId,
  defaultConditions,
  judgmentDivisions,
  conditionsRef,
  setConditionsAndSearch,
}: Props) {
  // フォームのデフォルト値
  /*
  const defaultValues = useMemo(() => {
    const modelUserIds = defaultConditions.model_user_ids?.map((x) => `user_${x}`);
    return { ...defaultConditions, model_user_ids: modelUserIds };
  }, [defaultConditions]);
*/
  // フォーム情報
  const { control, register, handleSubmit } = useForm<BaseManuscriptSearchConditions>({
    defaultValues: { ...defaultConditions },
  });

  // 言語情報
  const { t } = useTranslation();

  // フォーム送信
  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    void handleSubmit((data) => {
      const next: BaseManuscriptSearchConditions = {
        ...conditionsRef.current,
        production_id: productionId,
        l1: data.l1,
        l2: data.l2,
        l3: data.l3,
        l4: data.l4,
        subheading: data.subheading,
        judgment_ids: data.judgment_ids,
        description_items: data.description_items,
        ps_no: data.ps_no,
      };
      // 検索実行など
      setConditionsAndSearch(next);
    })();
  };
  return (
    <SlideToggle open={openSearchConditions}>
      <form id="basemanuscript-search-conditions" onSubmit={onSubmit}>
        <div className="wfr scondition trigfr fropen">
          <div className="grid3 labip3">
            <div>
              <label htmlFor="l1">{t('L1')}</label>
              <input type="text" id="l1" {...register('l1')} />
            </div>
            <div>
              <label htmlFor="l2">{t('L2')}</label>
              <input type="text" id="l2" {...register('l2')} />
            </div>
            <div>
              <label htmlFor="l3">{t('L3')}</label>
              <input type="text" id="l3" {...register('l3')} />
            </div>
            <div>
              <label htmlFor="l4">{t('L4')}</label>
              <input type="text" id="l4" {...register('l4')} />
            </div>
            <div>
              <label htmlFor="subheading">{t('小見出し')}</label>
              <input type="text" id="subheading" {...register('subheading')} />
            </div>
            <div> </div>
            <div>
              <label htmlFor="ps_no">{t('PS管理No')}</label>
              <input type="text" id="ps_no" {...register('ps_no')} />
            </div>
            <div>
              <label htmlFor="description">{t('記載項目')}</label>
              <MultiSelect
                id="description_items"
                name="description_items"
                options={[
                  { value: 1, label: t('タイトル') },
                  { value: 2, label: t('本文') },
                  { value: 3, label: t('イラスト') },
                ]}
                control={control}
                isDisabled={false}
                getValue={(x) => x.value}
                getLabel={(x) => x.label}
              />
            </div>
            <div>
              <label htmlFor="judgment_ids">{t('判定')}</label>
              <MultiSelect
                id="judgment_ids"
                name="judgment_ids"
                options={judgmentDivisions}
                control={control}
                isDisabled={false}
                getValue={(x) => x.judgment_division_id}
                getLabel={(x) => x.judgment_division_name}
              />
            </div>
          </div>
          <div className="controlfr mt20">
            <span>
              <input id="search" name="search" type="submit" value={t('絞り込み').toString()} className="searchbtn" />
            </span>
          </div>
        </div>
      </form>
    </SlideToggle>
  );
}
export { BaseManualSearch };
